module.exports = __webpack_public_path__ + "static/media/spells-splash-mockup.b313806f.png";